<script setup lang="ts">
import ExchangeRate from '@/api/ExchangeRate'
import Mode from '@/api/Mode'
import { useFetch } from '@/composables/fetch'
import useAppStore from '@/stores/app'
import useExchangeRateStore from '@/stores/exchange-rate'
import { storeToRefs } from 'pinia'
import { onMounted, watch } from 'vue'

const { fetch } = useFetch()
const appStore = useAppStore()
const exchangeRateStore = useExchangeRateStore()

const { currency, selectedRate, exchangeRates, testMode } = storeToRefs(appStore)

watch(
  currency,
  (newCurrency) => {
    const rate = exchangeRateStore.rates.find((r) => r.currency === newCurrency.selected)
    if (rate) {
      selectedRate.value = rate
    }
  },
  { deep: true }
)

onMounted(async () => {
  setTestMode()
  await setExchangeRates()
  await setCurrency()
})

const setExchangeRates = async () => {
  exchangeRateStore.rates = await ExchangeRate.get<Rate[]>()
  exchangeRates.value = exchangeRateStore.rates
}

const setTestMode = async () => {
  try {
    const response = await Mode.get<{ test: boolean }>()
    testMode.value = response.test
  } catch (error) {
    testMode.value = false
  }
}

const setCurrency = async () => {
  const getSelectedCurrency = (value = 'USD') => {
    const validCurrency = exchangeRateStore.rates.map((rate) => rate.currency)

    return !validCurrency.includes(value) ? 'USD' : value
  }

  if (currency.value.default === null) {
    const { data } = await fetch('geo-location').json()

    currency.value.default = getSelectedCurrency(data.value.currency)
    currency.value.selected = getSelectedCurrency(data.value.currency)
  }

  selectedRate.value =
    exchangeRateStore.rates.find((rate) => rate.currency === currency.value.selected) ||
    exchangeRateStore.rates[0]
}
</script>

<template>
  <div class="hidden"></div>
</template>
